module.exports = __webpack_public_path__ + "static/media/custom-wed-03.ef008819.jpg";